export const BookingChannel = ({ booking }) => {
  const channel = booking?.booking_channel;
  const channelName = channel?.name || booking?.channel;
  const channelLogo = channel?.logo_url;

  if (!channelName) return null;

  return (
    <dl>
      <dt className="label-info">Channel</dt>
      <dd className="BookingDetails__info">
        {channelLogo ? (
          <img
            className="BookingDetails__logo"
            src={channelLogo}
            alt={channelName}
          />
        ) : (
          <span>{channelName}</span>
        )}
      </dd>
    </dl>
  );
};
